__turbopack_context__.v({
  "btnBlock": "styles-module__czwVKa__btnBlock",
  "headerRow": "styles-module__czwVKa__headerRow",
  "iconInherit": "styles-module__czwVKa__iconInherit",
  "iconWrap": "styles-module__czwVKa__iconWrap",
  "mapLink": "styles-module__czwVKa__mapLink",
  "mobileWrap": "styles-module__czwVKa__mobileWrap",
  "position": "styles-module__czwVKa__position",
  "positionSaleBlock": "styles-module__czwVKa__positionSaleBlock",
  "typeCatalogContent": "styles-module__czwVKa__typeCatalogContent",
  "typeCatalogTitle": "styles-module__czwVKa__typeCatalogTitle",
  "typeCatalogTitleMobile": "styles-module__czwVKa__typeCatalogTitleMobile",
  "wrapSkeleton": "styles-module__czwVKa__wrapSkeleton",
});
